import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDPSLBLMxZklqM8bqq7tBZO-2rr-vfXSnU",
  authDomain: "chai-cheng-xun.firebaseapp.com",
  databaseURL: "https://chai-cheng-xun-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chai-cheng-xun",
  storageBucket: "chai-cheng-xun.appspot.com",
  messagingSenderId: "900501405818",
  appId: "1:900501405818:web:24111ad785ea1bef95fbc3",
  measurementId: "G-ZBLJE3E7NC"
};

export const app = initializeApp(firebaseConfig);
export const realtime = getDatabase(app);